(() => {
  if (customElements.get('wrpg-product-slider')) return;

  class WrpgProductSlider extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.slider = this.querySelector('[id^="Slider-"]');
      this.host = this.querySelector('slider-component');
      if (!this.slider) return;

      this.syncArrows = this.syncArrows.bind(this);
      this.slider.addEventListener('scroll', this.syncArrows, { passive: true });
      window.addEventListener('resize', this.syncArrows, { passive: true });
      requestAnimationFrame(() => {
        if (typeof this.host?.resetPages === 'function') this.host.resetPages();
        this.syncArrows();
      });

      if (this.dataset.autoScroll !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.paused = false;
      this.play();
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.play();
      });
      this.slider.addEventListener('pointerdown', () => this.pause());
    }

    disconnectedCallback() {
      this.pause();
      window.removeEventListener('resize', this.syncArrows);
    }

    overflow() {
      return Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
    }

    syncArrows() {
      const max = this.overflow();
      const atStart = this.slider.scrollLeft <= 8;
      const atEnd = this.slider.scrollLeft >= max - 8;
      this.classList.toggle('has-overflow', max > 8);
      this.classList.toggle('is-at-start', atStart || max <= 8);
      this.classList.toggle('is-at-end', atEnd || max <= 8);
      if (!this.host?.prevButton || !this.host?.nextButton) return;
      if (max <= 8) {
        this.host.prevButton.setAttribute('disabled', 'disabled');
        this.host.nextButton.setAttribute('disabled', 'disabled');
        return;
      }
      if (atStart) {
        this.host.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.host.prevButton.removeAttribute('disabled');
      }
      if (atEnd) {
        this.host.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.host.nextButton.removeAttribute('disabled');
      }
    }

    stepWidth() {
      const current = this.slider.querySelector('.slider__slide');
      if (!current) return this.slider.clientWidth;
      const next = current.nextElementSibling;
      if (next) return next.offsetLeft - current.offsetLeft;
      return current.getBoundingClientRect().width;
    }

    tick() {
      if (this.paused || !this.slider) return;
      const max = this.overflow();
      if (max <= 4) return;
      const next = this.slider.scrollLeft + this.stepWidth();
      this.slider.scrollTo({
        left: next >= max - 8 ? 0 : next,
        behavior: 'smooth',
      });
    }

    play() {
      this.paused = false;
      clearInterval(this.timer);
      this.timer = setInterval(() => this.tick(), 4000);
    }

    pause() {
      this.paused = true;
      clearInterval(this.timer);
    }
  }

  customElements.define('wrpg-product-slider', WrpgProductSlider);
})();
